

import React from 'react'

export default function LayersReferance({ color }) {
  return (
    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_2817_1249)">
        <path d="M26.3625 19.2087L28.75 20.6187L15 28.75L1.25 20.6162L3.6375 19.2062L4.86625 19.9337L3.7075 20.6175L15 27.2975L26.2912 20.62L25.1325 19.9362L26.3625 19.2087ZM24.375 14.375C24.375 14.4125 24.3662 14.445 24.3637 14.4812L26.2925 15.62L21.045 18.7237C20.7981 18.9464 20.5091 19.1173 20.195 19.2262L15 22.2975L3.70625 15.6175L6.875 13.7475V12.2962L1.25 15.6162L15 23.75L28.75 15.6187L24.375 13.035V14.375ZM17.5 8.75V7.5H11.25V8.75H17.5ZM12.5 10V11.25H16.25V10H12.5ZM8.75 3.125C8.75 2.075 9.94 1.25 11.4587 1.25H22.5V15H20V17.5H11.875C11.0464 17.4993 10.2519 17.1699 9.66602 16.584C9.08011 15.9981 8.75066 15.2036 8.75 14.375V3.125ZM10 3.125C10 3.34625 10.5537 3.75 11.4587 3.75H20V13.75H21.25V2.5H11.4587C10.5537 2.5 10 2.90375 10 3.125ZM10 14.375C10.0007 14.8721 10.1984 15.3486 10.5499 15.7001C10.9014 16.0516 11.3779 16.2493 11.875 16.25H18.75V5H11.4587C10.958 5.00445 10.4616 4.90662 10 4.7125V14.375Z" fill={color} />
      </g>
      <defs>
        <clipPath id="clip0_2817_1249">
          <rect width="30" height="30" fill={color} />
        </clipPath>
      </defs>
    </svg>
  )
}

